import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ChartTypes } from '@mode/shared/contract-common';
import { Subscription } from 'rxjs';
import { FormatListItem } from '../format-list-item';

const TITLE_DEFAULTS = {
  text: '',
  show: true,
} as const;

@Component({
  selector: 'mode-format-builder-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent implements OnChanges, OnDestroy {
  @Input() titleCheckboxLabel = 'Show title';
  @Input() titleInputLabel = 'Title';
  @Input() field!: FormatListItem;
  @Input() titleFormat!: ChartTypes.TitleFormat;
  @Output() update = new EventEmitter<ChartTypes.TitleFormat>();

  form = this.fb.group({
    text: [TITLE_DEFAULTS.text, { updateOn: 'blur' }],
    show: [TITLE_DEFAULTS.show],
  });

  subscription: Subscription;

  constructor(private fb: UntypedFormBuilder) {
    this.subscription = this.form.valueChanges.subscribe((titleFormat: ChartTypes.TitleFormat) => {
      this.update.emit(titleFormat);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.titleFormat) {
      this.form.patchValue(
        {
          ...TITLE_DEFAULTS,
          ...this.titleFormat,
        },
        {
          emitEvent: false,
        }
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
